<template>
    <div>
        <h6>How would you like to handle pick-up & drop-off?</h6>
        <div class="mt1 bodyCopy mid-gray">Delivery and pick-up services only apply within city limits.</div>

        <div class="pv3">
            <div v-if="listingData.renterPickup" class="mb3">
                <p-radio @change="resetLocation" value="renter_pickup" type="radio" class="formLabel p-pulse" name="handoff-method" color="warning" v-model="radio"><b>I'll pick-up & drop off myself</b></p-radio>
            </div>
            <div v-if="listingData.ownerDelivery" class="mb3">
                <p-radio value="owner_delivery" type="radio" class="formLabel p-pulse" name="handoff-method" color="warning" v-model="radio"><b>Owner delivery service (${{listingData.deliveryPrice}})</b></p-radio>
            </div>
            
            <p-radio v-if="listingData.tooliabaDelivery" value="tooliaba_delivery" type="radio" class="formLabel p-pulse" name="handoff-method" color="warning" v-model="radio"><b>Tooliaba delivery service ($19.99)</b></p-radio>
        </div>    
            <!-- drop-off address -->
            <div v-if="radio !== 'renter_pickup' && radio !== null">
                <h6 class="mb3">Where will this be delivered?</h6>
                <AddressSelection :location="location"/>
            </div>
        
    </div>
</template>

<script>
import WhiteButton from '@/components/buttons/WhiteButton.vue';
import FullAddressInput from '@/components/global/FullAddressInput.vue';
import AddressSelection from '@/components/global/AddressSelection.vue';
import { mapState, mapMutations } from 'vuex';

export default {
    components: {
        WhiteButton,
        FullAddressInput,
        AddressSelection
    },
    computed: {
        ...mapState('newRental', ['listingData', 'userInput']),
        radio: {
            get() {
                return this.userInput.deliveryType;
            },
            set(value) {
                this.updateDeliveryType(value);
            }
        },
        location: {
            get() {
                return this.userInput.location;
            },
            set(value) {
                this.updateLocation(value);
            }
        }
    },
    methods: {
        ...mapMutations('newRental', [
            'updateDeliveryType',
            'updateLocation',
            'resetLocation'
        ])
    }
};
</script>
